module.exports = __webpack_public_path__ + "img/Logo-Lintasarta.d819c7d3.png";